/** Keep in sync with `$layout-mobile-max` in `src/css/skeleton.scss`. */
export const LAYOUT_MOBILE_MAX_PX = 900
/** Keep in sync with `$navbar-duration` in `src/css/skeleton.scss`. */
export const NAV_RAIL_COLLAPSE_MS = 320
export const LAYOUT_COMPACT_MAX_PX = 599
export const LAYOUT_COMPACT_DIALOG_MAX_PX = 480

export const layoutMobileMediaQuery = `(max-width:${LAYOUT_MOBILE_MAX_PX}px)`
export const layoutCompactMediaQuery = `(max-width:${LAYOUT_COMPACT_MAX_PX}px)`
export const layoutCompactDialogMediaQuery = `(max-width:${LAYOUT_COMPACT_DIALOG_MAX_PX}px)`
